import React from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { PreviewItem } from 'Components/ComponentLibrary/Components/Uncategorized/FileViewer/components/PreviewItem';
import useMobileLayout from 'Hooks/useMobileLayout';
import { useWidth } from 'Hooks/useDimensions';

export const IncomeSalaryPayStubDetailsAttachmentDesktop = () => {
  const { resource } = useMetaLayoutContext();
  const [parentRef, width] = useWidth();

  const isMobile = useMobileLayout();

  if (isMobile) {
    return null;
  }


  return resource.withRelationship(fr.relationships.attachment.name, (rel) => {
    return (
      <div style={{ width: '100%', position: 'relative' }} ref={parentRef}>
        <div style={{
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
        }}
        >
          <PreviewItem
            presentsAsDownloadable={resource.withRelationship(fr.relationships.presentsAsDownloadable.name, () => true, () => false)}
            attachmentName={rel.meta('title')}
            attachmentHref={rel.link('related').url()}
            height={width * 2}
            width={width}
            alignItem={'top'}
          />
        </div>
      </div>
    );
  }, () => null);
};
